import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface BrowseCreatorsCacheState {
  cache: Record<string, any[]>
  timestamps: Record<string, number>
  setCache: (key: string, creators: any[]) => void
  getCache: (key: string) => any[] | undefined
  getTimestamp: (key: string) => number | undefined
  clear: () => void
}

export const useBrowseCreatorsCacheStore = create<BrowseCreatorsCacheState>()(
  persist(
    (set, get) => ({
      cache: {},
      timestamps: {},
      setCache: (key, creators) =>
        set(state => ({
          cache: { ...state.cache, [key]: creators },
          timestamps: { ...state.timestamps, [key]: Date.now() }
        })),
      getCache: key => get().cache[key],
      getTimestamp: key => get().timestamps[key],
      clear: () => set({ cache: {}, timestamps: {} })
    }),
    {
      name: 'browse-creators-cache',
      partialize: (state) => ({
        cache: state.cache,
        timestamps: state.timestamps
      })
    }
  )
)
